interface FamiliaItem {
  value: string
  text: string
}

interface OrigemFamiliaItem {
  value: number
  text: string
  tipo: number
  familias: Array<FamiliaItem>
}

export const tiposFamilia = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => ({ value: n, text: String(n) }))

export const origensFamilia: Array<OrigemFamiliaItem> = [
  {
    value: 11,
    text: '11 - Serviços Prestados',
    tipo: 1,
    familias: [{ value: '11.1', text: '11.1 - Serviços Farmacêuticos (código da prefeitura)' }],
  },
  {
    value: 12,
    text: '12 - Serviços Tomados',
    tipo: 1,
    familias: [
      { value: '12.1', text: '12.1 - Serviços Gerais' },
      { value: '12.2', text: '12.2 - Serviços Marketing & Evento' },
      { value: '12.3', text: '12.3 - Serviço de Locação' },
      { value: '12.4', text: '12.4 - Serviço Treinamento & Cursos' },
      { value: '12.6', text: '12.6 - Serviço T.I' },
      { value: '12.7', text: '12.7 - Serviço Manutenção Equipamentos' },
      { value: '12.8', text: '12.8 - Serviço Manutenção Predial' },
      { value: '12.9', text: '12.9 - Serviço de Locação de Equipamento' },
      { value: '12.10', text: '12.10 - Serviço Civil' },
      { value: '12.11', text: '12.11 - Serviço de Terceiros' },
    ],
  },
  {
    value: 21,
    text: '21 - Mercadorias (Revenda)',
    tipo: 2,
    familias: [
      { value: '21.1', text: '21.1 - Mercadorias Revenda' },
      { value: '21.2', text: '21.2 - Almoxarifado (Spex)' },
    ],
  },
  {
    value: 31,
    text: '31 - Mercadorias (Revenda) (controle lote e validade)',
    tipo: 3,
    familias: [
      { value: '31.1', text: '31.1 - Oftalmagic' },
      { value: '31.2', text: '31.2 - Suplementos' },
      { value: '31.3', text: '31.3 - Amostras' },
      { value: '31.4', text: '31.4 - PetScientia' },
    ],
  },
  {
    value: 41,
    text: '41 - Uso e Consumo',
    tipo: 4,
    familias: [
      { value: '41.1', text: '41.1 - Uso e Consumo' },
      { value: '41.2', text: '41.2 - Uso Consumo Embalagens' },
      { value: '41.3', text: '41.3 - Uso Consumo Marketing & Eventos' },
      { value: '41.4', text: '41.4 - Uso Consumo - Uniformes área central' },
      { value: '41.5', text: '41.5 - Uso Consumo - Materiais de Escritório, EPI, Descartáveis, Higiene, Utensílios' },
      { value: '41.6', text: '41.6 - Uso Consumo - T.I - Material de Informática & Licenças' },
      { value: '41.7', text: '41.7 - Uso Consumo - Material Manutenção Mobiliário & Predial & Elétrica & Hidráulica' },
      { value: '41.8', text: '41.8 - Uso e Consumo - Peças de manutenção fabril' },
      { value: '41.9', text: '41.9 - Uso Consumo Itens Qualidade' },
    ],
  },
  {
    value: 51,
    text: '51 - Matéria-Prima Veterinária (lote e validade)',
    tipo: 5,
    familias: [
      { value: '51.1', text: '51.1 - Veterinário Nacional' },
      { value: '51.2', text: '51.2 - Veterinário Internacional' },
    ],
  },
  {
    value: 52,
    text: '52 - Matéria-Prima Geral (lote e validade)',
    tipo: 5,
    familias: [
      { value: '52.1', text: '52.1 - Matéria Prima Geral Nacional' },
      { value: '52.2', text: '52.2 - Matéria Prima Geral Internacional' },
    ],
  },
  {
    value: 61,
    text: '61 - Embalagens e Rótulos Primária (controla lote e validade)',
    tipo: 6,
    familias: [
      { value: '61.1', text: '61.1 - Embalagem Primária' },
      { value: '61.2', text: '61.2 - Rótulos' },
    ],
  },
  {
    value: 71,
    text: '71 - Embalagens Secundária (não controla lote)',
    tipo: 7,
    familias: [
      { value: '71.1', text: '71.1 - Caixa de Embarque' },
      { value: '71.2', text: '71.2 - Caixa Isopor' },
    ],
  },
  {
    value: 81,
    text: '81 - Solução Intermediária (controla lote e validade)',
    tipo: 8,
    familias: [
      { value: '81.1', text: '81.1 - Bases e Excipientes' },
      { value: '81.2', text: '81.2 - Solução Intermediária' },
    ],
  },
  {
    value: 91,
    text: '91 - Produto Manipulado Semi Elaborado (controla lote e validade)',
    tipo: 9,
    familias: [{ value: '91.1', text: '91.1 - Semi elaborado (colírios e Tirzepatida)' }],
  },
  {
    value: 10,
    text: '10 - Imobilizado',
    tipo: 10,
    familias: [
      { value: '101.1', text: '101.1 - Ativo Imobilizado' },
      { value: '101.2', text: '101.2 - Ativo Imobilizado T.I - Equipamentos de TI' },
      { value: '101.3', text: '101.3 - Ativo Imobilizado - Móveis & Utensílios' },
      { value: '101.4', text: '101.4 - Ativo Imobilizado - Equipamentos Laboratório & Filiais' },
      { value: '101.5', text: '101.5 - Ativo Imobilizado Equipamentos & Filiais' },
      { value: '101.6', text: '101.6 - Benfeitorias e instalações elétricas em imóveis' },
      { value: '101.7', text: '101.7 - Veículos' },
    ],
  },
]
